import { Language, LayoutType } from './types';

export const LANGUAGE_KEY = 'language';

export const LAYOUT_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public'
} as const;

export const LANGUAGES = {
  en: { code: 'en', label: 'English', country: 'gb' },
  es: { code: 'es', label: 'Español', country: 'es' },
  fr: { code: 'fr', label: 'Français', country: 'fr' },
  pt: { code: 'pt', label: 'Português', country: 'pt' },
  it: { code: 'it', label: 'Italiano', country: 'it' },
  ar: { code: 'ar', label: 'العربية', country: 'sa', rtl: true },
  ru: { code: 'ru', label: 'Русский', country: 'ru' },
  zh: { code: 'zh', label: '中文', country: 'cn' }
} as const satisfies Record<string, Language>;

export const defaultLanguageForLayout: Record<LayoutType, Language['code']> = {
  private: LANGUAGES.en.code,
  public: LANGUAGES.en.code
};

export const LAYOUT_LANGUAGES = {
  private: [LANGUAGES.en, LANGUAGES.es, LANGUAGES.fr, LANGUAGES.pt],
  public: [
    LANGUAGES.en,
    LANGUAGES.es,
    LANGUAGES.it,
    LANGUAGES.fr,
    LANGUAGES.ar,
    LANGUAGES.pt,
    LANGUAGES.ru,
    LANGUAGES.zh
  ]
} as const satisfies Record<LayoutType, readonly Language[]>;
